"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var di_1 = require("../di");
var injection_strategy_1 = require("../enum/injection-strategy");
var type_string_1 = require("../../lang/type-string");
exports.injectable = function (injectionStrategyOrCtor, factoryFn) {
    if (injectionStrategyOrCtor === void 0) { injectionStrategyOrCtor = injection_strategy_1.InjectionStrategy.SINGLETON; }
    if (typeof injectionStrategyOrCtor === type_string_1.TYPE_STRING) {
        return function (originalCtor) {
            Object.defineProperty(originalCtor, di_1.INJECTION_STRATEGY, {
                value: {
                    injectionStrategy: injectionStrategyOrCtor,
                    factoryFn: factoryFn,
                },
            });
            return originalCtor;
        };
    }
    else {
        Object.defineProperty(injectionStrategyOrCtor, di_1.INJECTION_STRATEGY, {
            value: {
                injectionStrategy: injection_strategy_1.InjectionStrategy.SINGLETON,
                factoryFn: undefined,
            },
        });
        return injectionStrategyOrCtor;
    }
};
//# sourceMappingURL=injectable.js.map